import '../../node_modules/bootstrap/js/dist/carousel';
import '../../node_modules/bootstrap/js/dist/offcanvas';
import Tab from '../../node_modules/bootstrap/js/dist/tab';
import GLightbox from 'glightbox';

(function () {
	'use strict';

	function stickyHeader() {
		const $sticky = document.querySelectorAll(".sticky-top");
		if( $sticky.length < 1 )
			return;

		window.addEventListener('scroll', function() {
			for( let i=0; i<$sticky.length; i++ ) {
				$sticky[i].classList.toggle(
					'sticky-scrolled',
					$sticky[i].offsetTop > 0
				);
			}
		});
	}

	/**
	 * Automatically apply Lighbox on links to images
	 */
	function singleLightboxes() {
		const $links = document.querySelectorAll('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".webp"]');
		for( let i = 0; i< $links.length; i++ ) {
			if( typeof $links[i].getAttribute('data-js-glightbox-ready') === 'string' )
				continue;

			let id = $links[i].getAttribute('id');
			$links[i].setAttribute(
				'id',
				( typeof id !== 'string' || id.trim().length < 1 )
					? 'glightbox-' + (Math.random() + 1).toString(36).substring(10)
					: id
			);


			$links[i].classList.add('glightbox');
			let dataGlightbox = $links[i].getAttribute('data-glightbox');
			dataGlightbox = ( typeof dataGlightbox === 'string' ) ? dataGlightbox.split('; ') : [];

			if( $links[i].parentNode.nodeName.toUpperCase() === 'FIGURE' ) {
				let $captions = $links[i].parentNode.querySelectorAll('figcaption');
				for( let j = 0; j< $captions.length; j++ ) {
					dataGlightbox.push('description: ' + $captions[j].innerHTML);
					break;
				}
			}

			dataGlightbox.push('type: image');

			$links[i].setAttribute( 'data-glightbox', dataGlightbox.join('; ') );
			GLightbox({
				selector: '#' + $links[i].getAttribute('id')
			});
			$links[i].setAttribute('data-js-glightbox-ready', true);
		}
	}

	function galleryLightbox() {
		const $galleries = document.querySelectorAll(".wp-block-gallery");
		for( let i = 0; i< $galleries.length; i++ ) {
			// Generate unique ID
			const id = (Math.random() + 1).toString(36).substring(10);

			const $links = $galleries[i].querySelectorAll(".wp-block-image a");
			for( let j=0; j<$links.length; j++ ) {
				$links[j].setAttribute('data-gallery', 'bz-gallery-' + id);
				$links[j].setAttribute('data-js-glightbox-ready', true);
			}
			GLightbox({
				selector: '[data-gallery="bz-gallery-' + id +'"]',
			});
		}
	}

	/**
	 * Focus search input when Offcanvas is triggered
	 */
	function searchOffCanvas() {
		const $offCanvaSearch = document.getElementById('offcanvas-search');
		if( !$offCanvaSearch )
			return;

		$offCanvaSearch.addEventListener('shown.bs.offcanvas', function() {
			$offCanvaSearch.querySelector('input[type="search"]').focus();
		});
	}

	/**
	 * Bubble clicks on `bz-post-thumbnail-left` pattern
	 */
	function stretchedLinksOnPostsWithLeftThumbnail() {
		const $posts = document.querySelectorAll(".bz-post-thumbnail-left");
		for( let j=0; j<$posts.length; j++ ) {
			$posts[j].style.cursor = 'pointer';

			const $links = $posts[j].getElementsByTagName('a');
			if( typeof $links !== 'object' || $links.length < 1)
				continue;

			const href = $links[0].getAttribute('href');
			if( typeof href !== 'string' )
				continue;

			$posts[j].addEventListener('click', function() {
				window.location.href = href;
			});
		}
	}

	/**
	 * Fix custom implementation of Bootstrap Tabs by AREOI plugin
	 */
	function enableTabs() {
		const $tabs = document.querySelectorAll('.areoi-tabs');
		$tabs.forEach( $tabsWrapper => {
			const $navTabs = $tabsWrapper.querySelectorAll('.nav-tabs');
			$navTabs.forEach($navTabGroup => {
				let activeTabPaneID;

				// Replace links by buttons
				const triggerTabList = $navTabGroup.querySelectorAll('a.nav-link')
				triggerTabList.forEach(triggerEl => {
					var button = document.createElement('button');
					button.classList.add('nav-link');
					button.setAttribute('type', 'button');
					button.setAttribute('role', 'tab');
					button.setAttribute('data-bs-toggle', 'tab');
					button.setAttribute('data-bs-target', triggerEl.getAttribute('href'));
					button.setAttribute('aria-controls', triggerEl.getAttribute('href').replace('#', ''));
					button.setAttribute('aria-selected', triggerEl.getAttribute('aria-selected'));
					button.innerHTML = triggerEl.innerHTML;

					if( triggerEl.classList.contains('active') ) {
						button.classList.add('active');
						activeTabPaneID = triggerEl.getAttribute('href').replace('#', '');
					}

					triggerEl.parentNode.replaceChild(button, triggerEl);

					// Enable Tab logic
					const tabTrigger = new Tab(button);
					triggerEl.addEventListener('click', event => {
						event.preventDefault();
						tabTrigger.show();
					})
				});

				// Wrap tab panes in div.tab-content
				var $tabContent = document.createElement('div');
				$tabContent.classList.add('tab-content');
				$navTabGroup.parentNode.querySelectorAll('[role="tabpanel"]').forEach($tabPane => {
					$tabPane.classList.add('tab-pane');

					if( typeof activeTabPaneID === 'string' && $tabPane.getAttribute('id') === activeTabPaneID )
						$tabPane.classList.add('active');

					$tabContent.appendChild( $tabPane );
				});

				$navTabGroup.parentNode.appendChild( $tabContent );
			});
		});
	}

	function fixAreoiCarousels() {
		const $carousels = document.querySelectorAll('.carousel');
		$carousels.forEach( $carousel => {
			// Wrap carousel items in div.carousel-inner
			var $carouselInner = document.createElement('div');
			$carouselInner.classList.add('carousel-inner');
			$carousel.querySelectorAll('.carousel-item').forEach($item => {
				$carouselInner.appendChild( $item );
			});

			$carousel.appendChild( $carouselInner );
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		stickyHeader();
		galleryLightbox();
		singleLightboxes();
		searchOffCanvas();
		stretchedLinksOnPostsWithLeftThumbnail();
		enableTabs();
		fixAreoiCarousels();
	}, false);
})();
